import {
  combineReducers,
} from 'redux';

import applicationReducer from '../application/reducer';

import authorizedStateReducer from '../application/authorizedState/reducer';
import unauthorizedStateReducer from '../application/unauthorizedState/reducer';

const rootReducer = combineReducers({
  application: applicationReducer,
  authorizedState: authorizedStateReducer,
  unauthorizedState: unauthorizedStateReducer,
});

export default rootReducer;
